import eric from "../assets/eric.jpeg";
import sam from "../assets/sam.jpeg";

export const TEAM = [
  { imageUrl: eric, name: "Eric Chen", role: "Cofounder" },
  { imageUrl: sam, name: "Sam Postelnik", role: "Cofounder" },
];
